"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Checkable;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _getComponentName = _interopRequireDefault(require("react-utils/getComponentName"));

var _utils = require("./utils");

/**
 * Similar to `Controllable`, but specifically for controlling a `checked` property using the same
 * API as native checkbox/radio inputs: `checked`, `defaultChecked`, and `onChange`. Additionally,
 * the events passed to `onChange` use `evt.target.checked` instead of `evt.target.value`.
 *
 * @param {JSX.Component} Component
 * @returns {JSX.Component} A component with defaultable `checked` prop
 */
function Checkable(Component) {
  var CheckableComponent = (0, _react.forwardRef)(function (props, ref) {
    var checked = props.checked,
        onChange = props.onChange,
        rest = (0, _objectWithoutProperties2.default)(props, ["checked", "onChange"]);
    /* eslint-disable react-hooks/rules-of-hooks */

    var _useState = (0, _react.useState)(props.defaultChecked),
        _useState2 = (0, _slicedToArray2.default)(_useState, 2),
        checkedState = _useState2[0],
        checkedStateSetter = _useState2[1];

    var onChangeRef = (0, _react.useRef)();
    var handleChangeRef = (0, _react.useRef)();

    if (!handleChangeRef.current || onChangeRef.current !== onChange) {
      onChangeRef.current = onChange;

      handleChangeRef.current = function (evt) {
        checkedStateSetter(evt.target.checked);
        if (onChange) onChange(evt);
      };
    }
    /* eslint-enable react-hooks/rules-of-hooks */


    return _react.default.createElement(Component, (0, _extends2.default)({}, rest, {
      checked: checked !== undefined ? checked : checkedState,
      onChange: handleChangeRef.current,
      ref: ref
    }));
  });
  CheckableComponent.propTypes = (0, _extends2.default)({}, Component.propTypes, {
    checked: _propTypes.default.bool,
    defaultChecked: _propTypes.default.bool,
    onChange: _propTypes.default.func
  });
  CheckableComponent.defaultProps = (0, _extends2.default)({}, Component.defaultProps, {
    defaultChecked: Component.defaultProps && Component.defaultProps.checked != null ? Component.defaultProps.checked : false
  });
  delete CheckableComponent.defaultProps.checked;
  CheckableComponent.displayName = "Checkable(" + (0, _getComponentName.default)(Component) + ")";
  (0, _utils.attachWrappedComponent)(CheckableComponent, Component);
  return CheckableComponent;
}

module.exports = exports.default;